import type { CombinedError } from '@urql/vue'

export function readGqlError(errors: MaybeRef<CombinedError | undefined>): string[] {
  const gqlErrors = unref(errors)?.graphQLErrors || []

  const messages = gqlErrors.map((e): string => {
    // @ts-expect-error: missing type on validation
    return e?.extensions?.validation?.[0]?.[0] || e?.message
  })

  return messages
}
